import React from 'react'

import { TableAndDiningTypeSelection } from './TableAndDiningTypeSelection'
import { VenueLogo } from './VenueLogo'

export const VenueHeaderInfo = ({
  venue,
  orderingTypePrompt,
}: {
  venue: any
  orderingTypePrompt: boolean
}) => {
  return (
    <div className="px-4 pt-4">
      <div className="flex items-center justify-between">
        <div className="flex w-full flex-col items-start justify-center">
          <h1 className="flex-grow truncate my-heading-sm">{venue.name}</h1>
          <TableAndDiningTypeSelection
            venue={venue}
            orderingTypePrompt={orderingTypePrompt}
          />
        </div>

        <VenueLogo venueLogo={venue.logo} />
      </div>
    </div>
  )
}
